import { FC } from 'react';
import {
  Button,
  Dropdown,
  Icon,
  Menu,
  MenuItem,
  TableCell,
  TextBody,
} from '@pypestream/design-system';
import './permissions-table.scss';
import { HandleAddProject, ShortOrgType } from './permissions-table.types';

export type AddProjectCellProps = {
  org: ShortOrgType;
  isSavingDetails: boolean;
  handleAddProject: HandleAddProject;
};

export const AddProjectCell: FC<AddProjectCellProps> = ({
  org,
  isSavingDetails,
  handleAddProject,
}) => (
  <TableCell colspan={3}>
    {(org.availableProjects && org.availableProjects?.length > 0 && (
      <>
        <Button
          variant="ghost"
          size="small"
          id={`org-${org.id}-project-seletor`}
          i18nKey="manager/common:permissionAndAccessTable.addProject"
          disabled={isSavingDetails}
        >
          <Icon slot="prefix" name="add"></Icon>
          Add Project
        </Button>
        <Dropdown
          trigger={`org-${org.id}-project-seletor`}
          placement="bottom-start"
        >
          <Menu>
            {org.availableProjects?.map((project) => (
              <MenuItem
                key={project.id}
                onClick={() => {
                  handleAddProject({ project });
                }}
                disabled={isSavingDetails}
              >
                {project.name}
              </MenuItem>
            ))}
          </Menu>
        </Dropdown>
      </>
    )) ||
      (org.assignedProjects?.length == 0 && (
        <TextBody
          variant="secondary"
          size="small"
          i18nKey="manager/common:permissionAndAccessTable.projectsEmptyState"
        >
          This Org has no Projects. Create one to get started.
        </TextBody>
      )) ||
      null}
  </TableCell>
);
